import { render } from "./CandidatoCadastro.vue?vue&type=template&id=57c6a0c1&ts=true"
import script from "./CandidatoCadastro.vue?vue&type=script&lang=ts"
export * from "./CandidatoCadastro.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\UniRH\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__